import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
const useStyles = makeStyles(() => ({
  tableContainer: {
    borderRadius: 2,
    maxWidth: 700
  },
  tableCell: {
    width: 160
  },
  tableCellPointer: {
    cursor: "pointer"
  },
  tableCellBackground: {
    backgroundColor: "#f4f4f4"
  }
}));
const TableContent = ({
  content,
  bottomSpaceContainer = "",
  tableCellClick,
  subHeaderContainer = ""
}) => {
  const classes = useStyles();
  const {
    tableData = [],
    showHeader = false
  } = content;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    className: `${bottomSpaceContainer} ${!tableCellClick && subHeaderContainer}`
  }, tableData.length > 0 && Object.keys(tableData[0]).length !== 0 && /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    square: true,
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableBody, null, tableData.map((item, index) => /*#__PURE__*/React.createElement(TableRow, {
    key: index
  }, Object.keys(item).map((key, objectIndex) => {
    var _item$key2;
    return /*#__PURE__*/React.createElement(TableCell, {
      key: key,
      onClick: () => {
        var _item$key;
        return tableCellClick && tableCellClick((_item$key = item[key]) === null || _item$key === void 0 ? void 0 : _item$key.value, index, objectIndex);
      },
      className: `${classes.tableCell} ${tableCellClick && classes.tableCellPointer} ${showHeader && index === 0 && classes.tableCellBackground}`
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      dangerouslySetInnerHTML: {
        __html: (_item$key2 = item[key]) === null || _item$key2 === void 0 ? void 0 : _item$key2.value
      },
      component: "div",
      variant: showHeader && index === 0 ? "subtitle2" : "body2"
    }));
  }))))))));
};
TableContent.propTypes = {
  content: PropTypes.object.isRequired,
  bottomSpaceContainer: PropTypes.string,
  tableCellClick: PropTypes.func,
  subHeaderContainer: PropTypes.string
};
export default TableContent;